module.exports = __webpack_public_path__ + "static/media/roble_lucerna.12b86450.jpg";